export default __webpack_public_path__ + "static/media/pierre.f9405eee.jpg";